import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import api from './api';

const name = 'tickets';

const getListSchema = createAsyncThunk(
  'ticket/seatmap-schemas',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.getListSchemaApi(payload);
      return res;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const setSchemaRelationShip = createAsyncThunk(
  'ticket/set-schemas',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.setSchemaRelationShipApi(payload);
      return res;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const getSchemaRelationShip = createAsyncThunk(
  'ticket/set-schemas',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.getSchemaRelationShipApi(payload);
      return res;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const getItemsByTicketing = createAsyncThunk(
  'tickets/publish-events-name',
  async (payload) => {
    return api.getItemsByTicketing(payload);
  }
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      error: {},
      listSchema: [],
      merchantSchemas: [],
    },
    extraReducers: {
      [getListSchema.pending]: (state) => ({
        ...state,
        isLoading: true,
        listSchema: { ...state.listSchema },
      }),
      [getListSchema.fulfilled]: (state, action) => ({
        ...state,
        error: {},
        isLoading: false,
        listSchema: action.payload,
      }),
      [getListSchema.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getSchemaRelationShip.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getSchemaRelationShip.fulfilled]: (state, action) => ({
        ...state,
        error: {},
        isLoading: false,
        merchantSchemas: action.payload,
      }),
      [getSchemaRelationShip.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
    },
  }),
};

const selectors = {
  selectIsLoading: (state) => getOr(false, 'isLoading', state[name]),
  selectListSchema: (state) => getOr([], 'listSchema', state[name]),
  selectSchemaRelationShip: (state) =>
    getOr([], 'merchantSchemas', state[name]),
};

export default {
  actions: {
    ...actions,
    getListSchema,
    setSchemaRelationShip,
    getSchemaRelationShip,
    getItemsByTicketing,
  },
  selectors,
  reducer,
  name,
};
